// ANGULAR
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// SERVICES
import { GlobalService } from '@services/global.service';
// MODELS
import { TokensCfg, TokensSettings } from '@models/tokens.model';
// RXJS
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokensService {
  readonly httpOptions: { headers: HttpHeaders, params: HttpParams } = { headers: new HttpHeaders({ 'content-type': 'application/json', 'accept': 'application/json' }), params: new HttpParams() };

  constructor(
    private globalService: GlobalService,
    private http: HttpClient
  ) { }

  getTokensCfg(): Observable<TokensCfg> {
    return this.http.get<TokensCfg>(`${this.globalService.apiUrl.url}/Tokens/Cfg`, this.httpOptions);
  }

  postTokensCfg(tokensSettings: TokensSettings): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Tokens/Cfg`, tokensSettings, this.httpOptions);
  }

  postRotateTokensCfgPassword(): Observable<TokensCfg> {
    return this.http.post<TokensCfg>(`${this.globalService.apiUrl.url}/Tokens/RotatePassword`, null, this.httpOptions);
  }

  postRevokeTokensCfgOldPassword(): Observable<void> {
    return this.http.post<void>(`${this.globalService.apiUrl.url}/Tokens/RevokeOldPassword`, null, this.httpOptions);
  }
}